import endpoints from '../../config/endpoints';
import { Sidebar } from "../../layouts/Sidebar";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { setLoading } from "../../services/reducers/homeSlice";
import restApi from "../../services/restApi";
import Swal from "sweetalert2";
import { useNavigate, useParams } from "react-router-dom";

const EditYear = () => {
  const [item, setItem] = useState<any>()
  const [greg, setGreg] = useState('');
  const dispatch = useDispatch();
  const { id } = useParams();
  const navigate= useNavigate()

  const send = async () => {
    dispatch(setLoading(true));
    
    const res = await restApi(endpoints.year + id, true).put({
      description: greg
    })
    
    if(res.code == 200){
      Swal.fire({
        title: 'موفق',
        text: 'سال با موفقیت ویرایش شد',
        icon: 'success',
        confirmButtonText: 'متوجه شدم'
      })
    } else {
      Swal.fire({
        title: 'ناموفق',
        text: res?.data,
        icon: 'error',
        confirmButtonText: 'متوجه شدم'
      })
    }
    
    dispatch(setLoading(false));
  }
  
  const fetchItem = async () => {
    dispatch(setLoading(true))
    
    const res = await restApi(endpoints.year + id, true).get()
    
    if(res.code == 200) {
      setItem(res.data)
    }
    
    dispatch(setLoading(false))
  }
  
  useEffect(() => {
    fetchItem()
  }, [])

  return (
    <>
      <body className="dashboardBody">
      <Sidebar />
      <main className="dashBoardMain main">
        <div className="addInfoHeader">
          <span className="dashboardHeader keepRight clickable" onClick={send}>
           ارسال
          </span>
          <span>
            <h1 className="sideBarTitle">بازگشت به صفحه لیست سال</h1>
             <h1 className="dashBoardTitle">ویرایش دسته بندی  مشخصات </h1>
          </span>
          <i className="backAdd clickable" onClick={() => navigate("/year/")}></i>
        </div>
        <section className="bottomSection">
          <h1 className="dashBoardTitle">اطلاعات سال</h1>
          <form className="addInfo">
            <label className="sideBarTitle" htmlFor="infoAmount">سال میلادی</label>
            <input className="addInput" placeholder="سال میلادی" id="infoAmount" onChange={(input: any) => setGreg(input.target.value)} defaultValue={item?.greg}/>
          </form>
        </section>
      </main>
      </body>
    </>
  )
}
export default EditYear;